import React, { useEffect, useState } from 'react';

const Certifications = () => {
  const [certs, setCerts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('/certifications.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load certifications data');
        return res.json();
      })
      .then(setCerts)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-certifications"><p>Loading...</p></section>;
  if (error) return <section className="resume-certifications"><p>Error: {error}</p></section>;

  return (
    <section className="resume-certifications">
      <h2>Certifications</h2>
      <ul style={{listStyle: 'none', padding: 0}}>
       
        {certs.map((cert, idx) => (
           <li key={idx} style={{marginBottom: '18px'}}>
            
            <div className="project-item">
              <h3 key={idx}>{cert}</h3>
            </div>
            </li>
        ))}
      </ul>
    </section>
  );
};

export default Certifications;
